export var SelectedDrawPlace;
(function (SelectedDrawPlace) {
    SelectedDrawPlace["HOME"] = "home";
    /** Brick and Mortar */
    SelectedDrawPlace["LAB"] = "lab";
})(SelectedDrawPlace || (SelectedDrawPlace = {}));
//# sourceMappingURL=segment.js.map